import { FieldRenderProps } from "react-final-form";

import { Switch } from "@livechat/design-system-react-components";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const FinalFormSwitch = ({ input }: FieldRenderProps<string, HTMLInputElement>) => (
  <Switch {...input} on={input.checked} />
);
